export const GET_USER_DECLARATIONS = 'GET_USER_DECLARATIONS';
export const UPDATE_USER_DECLARATIONS = 'UPDATE_USER_DECLARATIONS';
